import React from 'react';

import SavedSearchesBar from 'src/common/ui/SavedSearchesBar';

import { SearchState } from '../SearchPage';
import {
  getSavedSearches,
  removeSavedSearch,
  MAX_SAVED_SEARCHES,
  SAVED_SEARCHES_CHANGED_EVENT,
} from './savedSearchUtils';

interface SavedSearchesBarProps {
  readonly onLoadSearch: (state: SearchState) => void;
}

/** Search page's saved search chips. Presentation lives in the shared bar. */
const SearchSavedSearchesBar: React.FC<SavedSearchesBarProps> = ({
  onLoadSearch,
}) => (
  <SavedSearchesBar<SearchState>
    getSearches={getSavedSearches}
    removeSearch={removeSavedSearch}
    changedEvent={SAVED_SEARCHES_CHANGED_EVENT}
    onLoadSearch={onLoadSearch}
    label="Saved Searches:"
    hint={`(max ${MAX_SAVED_SEARCHES} — oldest auto-deleted)`}
    itemTestId="saved-search"
  />
);

export default SearchSavedSearchesBar;
